import React, { useState } from "react";
import { useUserContext } from "../../utils/UserContext";
import { tincPermis } from "../../utils/Permisos";
import Seleccionarmaterials from "./Seleccionarmaterials";
import Detallsmaterial from "./Detallsmaterial";
import "../dashboard_v2.css";
import AjudaCataleg from "./AjudaCataleg";
import { BotoAjuda } from "./AjudaModal";

function idMaterial(m) {
  return m ? Number(m.idMaterials) : null;
}

function Materials() {
  const [activeTab, setActiveTab] = useState("seleccionar");
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [categoriaFilter, setCategoriaFilter] = useState("");
  const [tipusFilter, setTipusFilter] = useState("");
  const [mostrarActius, setMostrarActius] = useState(true);
  const [reloadToken, setReloadToken] = useState(0);
  const [materialsList, setMaterialsList] = useState([]);
  const [mostraAjuda, setMostraAjuda] = useState(false);

  const { rolUsuari } = useUserContext();

  const tornarLlista = (refresca = false) => {
    setActiveTab("seleccionar");
    if (refresca) setReloadToken((n) => n + 1);
  };

  const handleMaterialSelect = (material) => {
    setSelectedMaterial((prev) => (idMaterial(prev) === idMaterial(material) ? null : material));
  };

  const obrirFitxa = (material, mode) => {
    setSelectedMaterial(material);
    setActiveTab(mode);
  };

  const esLlista = activeTab === "seleccionar";

  return (
    <div className="dv2 dv2-page dv2-page--fill">
      {mostraAjuda && <AjudaCataleg pestanya="materials" onTancar={() => setMostraAjuda(false)} />}
      {esLlista ? (
        <>
          <div className="dv2-pageHeader">
            <div className="dv2-pageHeader-main">
              <div className="dv2-pageHeader-icon" aria-hidden="true">
                🧱
              </div>
              <div>
                <h1 className="dv2-pageHeader-title">Materials</h1>
                <p className="dv2-pageHeader-subtitle">
                  Cada material pertany a un tipus i, per tant, a una categoria.
                </p>
              </div>
            </div>
            <div className="dv2-pageHeader-actions">
              <BotoAjuda title="Com funcionen els Materials" onClick={() => setMostraAjuda(true)} />
              {tincPermis(rolUsuari, "CREAR") && (
                <button
                  type="button"
                  className="dv2-btn dv2-btn--primary"
                  onClick={() => {
                    setSelectedMaterial(null);
                    setActiveTab("nou");
                  }}
                >
                  Nou material
                </button>
              )}
            </div>
          </div>

          <Seleccionarmaterials
            onMaterialSelect={handleMaterialSelect}
            onConsultar={(material) => obrirFitxa(material, "consultar")}
            onModificar={(material) => obrirFitxa(material, "modificar")}
            onEsborrar={(material) => obrirFitxa(material, "esborrar")}
            selectedMaterial={selectedMaterial}
            filterText={filterText}
            setFilterText={setFilterText}
            categoriaFilter={categoriaFilter}
            setCategoriaFilter={setCategoriaFilter}
            tipusFilter={tipusFilter}
            setTipusFilter={setTipusFilter}
            mostrarActius={mostrarActius}
            setMostrarActius={setMostrarActius}
            reloadToken={reloadToken}
            setMaterialsList={setMaterialsList}
          />
        </>
      ) : (
        <Detallsmaterial
          mode={activeTab}
          material={activeTab === "nou" ? null : selectedMaterial}
          materialsLlista={materialsList}
          onNavigate={setSelectedMaterial}
          onCancel={() => tornarLlista(false)}
          onDeleted={() => tornarLlista(true)}
          onCanviarMode={(modeNou) => setActiveTab(modeNou)}
          onSave={(updated) => {
            if (activeTab === "nou") {
              tornarLlista(true);
              return;
            }
            setSelectedMaterial(updated);
            setMaterialsList((prev) =>
              (prev || []).map((m) => (idMaterial(m) === idMaterial(updated) ? { ...m, ...updated } : m))
            );
            setActiveTab("consultar");
          }}
        />
      )}
    </div>
  );
}

export default Materials;
